module.exports = __webpack_public_path__ + "static/media/tick-colored.eb26f02f.svg";